import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: -webkit-flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 48px;

  @media (max-width: 768px) {
    gap: 24px;
  }
`;

function Container({ children }) {
  return <Wrapper>{children}</Wrapper>;
}

export default Container;
